// Vendor modules
import "@uirouter/angularjs";
import 'angular-ui-bootstrap';
import './sf-webhooks';

import SFLoginComponent from './sf-login/sf-login.component';

const DEPENDENCIES = [
    'ui.router',
    'record-utilities',
    'ui.bootstrap',
    'ais.sf-webhooks'
  ];
angular.module('providers.salesforce', DEPENDENCIES)
    .component('sfLogin', SFLoginComponent);





